import axios from 'axios'

import { API_BASE_URL } from 'utils/consts.mjs'

type SurveyQuestionType =
  | 'user_role'
  | 'seo_experience_level'
  | 'reason_for_visiting'
  | 'industry'
  | 'company_size'

interface SurveyQuestion {
  question: SurveyQuestionType
  answer: string
  supplementary_answer?: string
}

export interface SurveyPayload {
  survey_name: string
  survey: SurveyQuestion[]
}

export const createSurveyAnswer = async (surveyData: SurveyPayload) => {
  return axios({
    withCredentials: true,
    method: 'post',
    baseURL: API_BASE_URL,
    url: '/user/survey',
    data: surveyData,
  })
}
